(() => {
  if (customElements.get('delivery-date-geo')) return

  class DeliveryDateGeo extends HTMLElement {
    connectedCallback () {
      let dates = {}
      try {
        dates = JSON.parse(this.dataset.dates || '{}')
      } catch (e) {
        dates = {}
      }
      this.dates = dates
      if (!Object.keys(this.dates).length) return
      this.pollAttempts = 0
      this.resolveCountry()
    }

    resolveCountry () {
      const selector = window.tbStoreSelector
      if (selector && selector.country) {
        this.applyCountry(selector.country)
        return
      }
      this.pollAttempts += 1
      if (this.pollAttempts >= 30) {
        const fallback = this.getCachedCountry() || this.dataset.fallbackCountry
        if (fallback) this.applyCountry(fallback)
        return
      }
      setTimeout(() => this.resolveCountry(), 100)
    }

    getCachedCountry () {
      try {
        const session = sessionStorage.getItem('tentboxSessionIpInfo')
        if (session) {
          const data = JSON.parse(session)
          const code = data.country_code || data.country
          if (code) return code
        }
      } catch (e) {
        /* noop */
      }
      try {
        const local = localStorage.getItem('tentboxIpInfo')
        if (local) {
          const parsed = JSON.parse(local)
          const data = parsed.data || parsed
          const code = data.country_code || data.country
          if (code) return code
        }
      } catch (e) {
        /* noop */
      }
      return null
    }

    applyCountry (countryCode) {
      const code = String(countryCode).toUpperCase()
      const date = this.dates[code]
      if (!date) return
      const target = this.querySelector('[data-delivery-geo-date]')
      if (target) target.textContent = date
    }
  }

  customElements.define('delivery-date-geo', DeliveryDateGeo)
})()
